<header class="header-modern ">
  <svg height="100" width="100%" class="header-bg" viewBox="0 0 1440 200" preserveAspectRatio="none">
    <path d="
    M0 0
    H1440
    V45
    Q1434 115 1295 115
    H163
    Q5 110 0 200
    Z
  " fill="#3cab8d" />
  </svg>

  <svg height="180" width="100%" class="header-bg-mobile" viewBox="0 0 1440 200" preserveAspectRatio="none">
    <path d="M0 0 H1440 V56 Q1440 112 1124 114 H219 Q37 117 0 200 Z" fill="#3cab8d" />
  </svg>

  <div class="container header-content" [ngClass]="{'has-two-logos': FunnelFlow.PathLogo}">
    <img *ngIf="pathLogoBrand" [src]="pathLogoBrand" alt="Logo" class="logo">

    <div class="right-group">
      <img *ngIf="FunnelFlow.PathLogo" [src]="FunnelFlow.PathLogo" alt="Logo" class="logo">

      <div class="phone-badge" *ngIf="brandNumber">
        <i class="fas fa-phone-alt"></i>
        <span>{{ brandNumber }}</span>
      </div>
    </div>
  </div>

</header>